import { render, staticRenderFns } from "./RefsGroup.vue?vue&type=template&id=5ebf2664&scoped=true"
import script from "./RefsGroup.vue?vue&type=script&lang=ts"
export * from "./RefsGroup.vue?vue&type=script&lang=ts"
import style0 from "./RefsGroup.vue?vue&type=style&index=0&id=5ebf2664&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf2664",
  null
  
)

export default component.exports